import { Typography, Switch } from '@material-tailwind/react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

const Switcher = ({ label, type, value, onChange, t }) => {
  return (
    <div className='px-4 py-4 bg-gray-50 rounded-2xl justify-start items-center gap-2 inline-flex'>
      <Switch
        id={`${label}-${type}`}
        checked={value === 'active'}
        onChange={onChange}
        color='blue'
        label={
          <>
            <Typography variant='medium' className='font-medium'>
              {t(`${label}.switch.${type}.${value}.title`)}
            </Typography>
            <Typography variant='small' className='font-medium'>
              {t(`${label}.switch.${type}.${value}.subTitle`)}
            </Typography>
          </>
        }
      />
    </div>
  )
}

Switcher.propTypes = {
  label: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  value: PropTypes.oneOf(['active', 'inactive']),
  onChange: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
}

export const StatusSwitcher = withTranslation()(Switcher)
